export const en = {
  resourcesList: [
    {
      name: "European Vegetation Syntheses",
      linkTo: "/project1",
      img: "important-main-project1_en"
    },
    {
      name: "Biodiversity of European cities",
      linkTo: "/project3",
      img: "important-main-project3_en"
    },
    {
      name: "Czech Vegetation Database",
      linkTo: "https://czechveg.github.io/",
      img: "resources-cnfd_en"
    },
    {
      name: "JUICE",
      linkTo: "/juice",
      img: "resources-juice"
    },
    {
      name: "Pladias",
      linkTo: "/pladias",
      img: "resources-pladias_en"
    },
    {
      name: "European Vegetation Archive",
      linkTo: "/eva",
      img: "resources-eva_en"
    }
  ]
};

export const cz = {
  resourcesList: [
    {
      name: "Evropské vegetační syntézy",
      linkTo: "/project1",
      img: "important-main-project1_cz"
    },
    {
      name: "Biodiverzita měst",
      linkTo: "/project3",
      img: "important-main-project3_cz"
    },
    {
      name: "Česká vegetační databáze",
      linkTo: "https://czechveg.github.io/",
      img: "resources-cnfd_cz"
    },
    {
      name: "JUICE",
      linkTo: "/juice",
      img: "resources-juice"
    },
    {
      name: "Pladias",
      linkTo: "/pladias",
      img: "resources-pladias_cz"
    },
    {
      name: "European Vegetation Archive",
      linkTo: "/eva",
      img: "resources-eva_cz"
    }
  ]
};
